// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --detail-surface: #f5f7fa;
  --detail-card-bg: #ffffff;
  --detail-card-radius: 16px;
  --detail-card-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  --detail-card-shadow-hover: 0 4px 24px rgba(0, 0, 0, 0.10);
  --detail-text-primary: #1a1a2e;
  --detail-text-secondary: #6b7280;
  --detail-text-tertiary: #9ca3af;
  --detail-pill-radius: 100px;
  --detail-transition: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  --detail-spring: 400ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

ion-title.title-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 0;
  right: 0;
  width: auto;
  max-width: calc(100% - 120px);
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
}

.skeleton-container {
  padding: 16px;
}
.skeleton-container .skeleton-hero {
  height: 180px;
  border-radius: var(--detail-card-radius);
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 300% 100%;
  animation: shimmer 1.8s ease-in-out infinite;
  margin-bottom: 20px;
}
.skeleton-container .skeleton-line {
  height: 14px;
  border-radius: 8px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 300% 100%;
  animation: shimmer 1.8s ease-in-out infinite;
  margin-bottom: 12px;
}
.skeleton-container .skeleton-line.w-60 {
  width: 60%;
}
.skeleton-container .skeleton-line.w-80 {
  width: 80%;
}
.skeleton-container .skeleton-line.w-40 {
  width: 40%;
}
.skeleton-container .skeleton-card {
  height: 80px;
  border-radius: 12px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 300% 100%;
  animation: shimmer 1.8s ease-in-out infinite;
  margin-bottom: 12px;
}

@keyframes shimmer {
  0% {
    background-position: 300% 0;
  }
  100% {
    background-position: -300% 0;
  }
}
.hero-card {
  position: relative;
  border-radius: 0 0 var(--detail-card-radius) var(--detail-card-radius);
  overflow: hidden;
  margin-bottom: 0;
}
.hero-card .hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-color: var(--hero-color);
}
.hero-card .hero-gradient {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(180deg, color-mix(in srgb, var(--hero-color) 30%, transparent) 0%, color-mix(in srgb, var(--hero-color) 85%, transparent) 60%, var(--hero-color) 100%);
}
.hero-card .hero-body {
  position: relative;
  z-index: 2;
  padding: 64px 20px 28px;
}
.hero-card .meta-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.hero-card .meta-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: var(--detail-pill-radius);
  background: rgba(255, 255, 255, 0.25);
  transform: translateZ(0);
  font-size: 0.82rem;
  font-weight: 500;
  color: #fff;
}
.hero-card .meta-pill ion-icon {
  font-size: 1rem;
}
.hero-card .meta-pill .dot {
  opacity: 0.6;
  margin: 0 2px;
}
.hero-card .track-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
}
.hero-card .track-chip {
  padding: 4px 12px;
  border-radius: var(--detail-pill-radius);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.hero-card .session-title {
  font-size: 1.65rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.3px;
}

.section {
  padding: 20px 20px 0;
}
.section .section-title {
  font-size: 1rem;
  margin: 0 0 10px;
}

.description-section {
  overflow-x: hidden;
}
.description-section .section-body {
  font-size: 0.92rem;
  line-height: 1.65;
  color: var(--detail-text-secondary);
  font-weight: 400;
}
.description-section .section-body ::ng-deep p {
  margin: 0 0 12px;
}
.description-section .section-body ::ng-deep img {
  max-width: 100%;
  border-radius: 10px;
}
.description-section .section-body ::ng-deep iframe {
  max-width: 100%;
  width: 100%;
  border: 0;
  border-radius: 10px;
}
.description-section .section-body ::ng-deep video,
.description-section .section-body ::ng-deep embed,
.description-section .section-body ::ng-deep object {
  max-width: 100%;
}
.description-section .section-body ::ng-deep table {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  display: block;
}

.video-section {
  padding-top: 8px;
}
.video-section .video-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}
.video-section .video-wrapper iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.reactions-section {
  padding: 16px 20px 8px;
}
.reactions-section .reactions-row {
  display: flex;
  justify-content: center;
  gap: 6px;
}
.reactions-section .reaction-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 14px;
  border-radius: 12px;
  background: var(--detail-card-bg);
  border: 1px solid rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform var(--detail-spring), box-shadow var(--detail-transition);
  min-width: 60px;
}
.reactions-section .reaction-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.reactions-section .reaction-btn:active {
  transform: scale(0.92);
}
.reactions-section .reaction-btn.active {
  border-color: var(--menu-color, #2973a2);
  background: rgba(from var(--menu-color, #2973a2) r g b/0.08);
}
.reactions-section .reaction-btn .reaction-emoji {
  font-size: 1.5rem;
  line-height: 1;
}
.reactions-section .reaction-btn .reaction-count {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--detail-text-secondary);
}

.speakers-section .speakers-scroll {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.speakers-section .speaker-card {
  flex: 1 1 130px;
  max-width: 160px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  border-radius: 14px;
  background: var(--detail-card-bg);
  box-shadow: var(--detail-card-shadow);
  cursor: pointer;
  transition: transform var(--detail-spring), box-shadow var(--detail-transition);
}
.speakers-section .speaker-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--detail-card-shadow-hover);
}
.speakers-section .speaker-card:active {
  transform: scale(0.96);
}
.speakers-section .speaker-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #f0f0f0;
}
.speakers-section .speaker-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.speakers-section .speaker-avatar .avatar-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #aaa;
}
.speakers-section .speaker-info {
  text-align: center;
  min-width: 0;
  width: 100%;
}
.speakers-section .speaker-info .speaker-name {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--detail-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.speakers-section .speaker-info .speaker-title {
  display: block;
  font-size: 0.7rem;
  color: var(--detail-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}
.speakers-section .speaker-info .speaker-company {
  display: block;
  font-size: 0.68rem;
  color: var(--detail-text-tertiary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1px;
}

.locations-section .location-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.locations-section .location-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--detail-card-bg);
  box-shadow: var(--detail-card-shadow);
}
.locations-section .location-item .loc-icon {
  font-size: 1.2rem;
  color: var(--menu-color, #2973a2);
  flex-shrink: 0;
}
.locations-section .location-item span {
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--detail-text-primary);
}

.documents-section ::ng-deep app-documents .cdk-virtual-scroll-viewport {
  max-height: none !important;
}
.documents-section ::ng-deep app-documents ion-item {
  --padding-start: 0;
  --inner-padding-end: 0;
  --background: transparent;
}

.custom-fields-section .custom-field {
  padding: 16px;
  border-radius: 12px;
  background: var(--detail-card-bg);
  box-shadow: var(--detail-card-shadow);
  margin-bottom: 10px;
}
.custom-fields-section .custom-field:last-child {
  margin-bottom: 0;
}
.custom-fields-section .cf-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--detail-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
.custom-fields-section .cf-value {
  font-size: 0.9rem;
  color: var(--detail-text-primary);
  line-height: 1.55;
}

.interactivity-section {
  margin-top: 24px;
  padding: 0 20px 20px;
}

.segment-sticky {
  position: sticky;
  top: 0;
  z-index: 15;
  padding: 8px 0;
  background: var(--detail-surface);
}
.segment-sticky ion-segment {
  --background: rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 3px;
  min-height: 44px;
}
.segment-sticky ion-segment ion-segment-button {
  --background-checked: var(--detail-card-bg);
  --color: var(--detail-text-secondary);
  --color-checked: var(--menu-color, #2973a2);
  --indicator-color: transparent;
  --border-radius: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  min-height: 38px;
  letter-spacing: 0;
}
.segment-sticky ion-segment ion-segment-button ion-icon {
  font-size: 1.1rem;
  margin-right: 4px;
}
.segment-sticky ion-segment ion-segment-button::part(indicator) {
  display: none;
}

.sidebar-segment {
  margin-bottom: 16px;
}
.sidebar-segment ion-segment {
  --background: rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  padding: 3px;
}
.sidebar-segment ion-segment ion-segment-button {
  --background-checked: var(--detail-card-bg);
  --color: var(--detail-text-secondary);
  --color-checked: var(--menu-color, #2973a2);
  --indicator-color: transparent;
  --border-radius: 10px;
  font-size: 0.8rem;
  min-height: 38px;
}
.sidebar-segment ion-segment ion-segment-button ion-icon {
  font-size: 1rem;
  margin-right: 4px;
}
.sidebar-segment ion-segment ion-segment-button::part(indicator) {
  display: none;
}

.sidebar-content {
  background: var(--detail-card-bg);
  border-radius: 14px;
  box-shadow: var(--detail-card-shadow);
  overflow: hidden;
}

.tab-content {
  background: var(--detail-card-bg);
  border-radius: 14px;
  box-shadow: var(--detail-card-shadow);
  overflow: hidden;
  margin-top: 12px;
}

.tab-content-inner {
  padding: 4px 0;
}

.personal-cta {
  padding: 8px 20px 24px;
}

.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px 20px;
  border-radius: 14px;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform var(--detail-spring), box-shadow var(--detail-transition);
}
.cta-button:hover {
  transform: translateY(-1px);
}
.cta-button:active {
  transform: scale(0.97);
}
.cta-button.has-badge {
  justify-content: space-between;
}
.cta-button.added {
  background: rgba(from var(--menu-color, #2973a2) r g b/0.1);
  color: var(--menu-color, #2973a2);
  border: 1.5px solid rgba(from var(--menu-color, #2973a2) r g b/0.25);
}
.cta-button.add {
  background: var(--menu-color, #2973a2);
  color: var(--menu-text-color, #ffffff);
  box-shadow: 0 4px 20px rgba(from var(--menu-color, #2973a2) r g b/0.35);
}
.cta-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.cta-button.disabled:hover {
  transform: none;
}
.cta-button.disabled:active {
  transform: none;
}
.cta-button .cta-start {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.cta-button .cta-start ion-icon {
  font-size: 1.3rem;
  flex-shrink: 0;
}
.cta-button .cta-start .cta-label {
  font-size: 0.95rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cta-button .cta-badge {
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  color: inherit;
}
.cta-button .cta-badge.sold-out {
  background: rgba(255, 255, 255, 0.25);
  font-weight: 600;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.conflict-message {
  margin: 10px 0 0;
  font-size: 0.82rem;
  font-weight: 500;
  color: #e53935;
  text-align: center;
  line-height: 1.4;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
}

@media (min-width: 992px) {
  .hero-card .hero-body {
    padding: 80px 32px 28px;
  }
  .section {
    padding: 24px 32px 0;
  }
  .reactions-section {
    padding: 16px 32px 8px;
  }
  .personal-cta {
    padding: 8px 32px 32px;
  }
  .detail-grid {
    grid-template-columns: 1.2fr 1fr;
    gap: 24px;
    padding: 24px 0;
    max-width: 1200px;
    margin: 0 auto;
  }
  .detail-main .hero-card {
    border-radius: var(--detail-card-radius);
    margin: 0 32px;
  }
  .detail-main .hero-card .hero-bg,
  .detail-main .hero-card .hero-gradient {
    border-radius: var(--detail-card-radius);
  }
  .detail-sidebar {
    position: sticky;
    top: 16px;
    align-self: start;
  }
}
.hero-card,
.section,
.reactions-section,
.interactivity-section,
.personal-cta {
  opacity: 0;
  animation: fadeSlideUp 450ms ease-out forwards;
}
.hero-card:nth-child(1),
.section:nth-child(1),
.reactions-section:nth-child(1),
.interactivity-section:nth-child(1),
.personal-cta:nth-child(1) {
  animation-delay: 40ms;
}
.hero-card:nth-child(2),
.section:nth-child(2),
.reactions-section:nth-child(2),
.interactivity-section:nth-child(2),
.personal-cta:nth-child(2) {
  animation-delay: 80ms;
}
.hero-card:nth-child(3),
.section:nth-child(3),
.reactions-section:nth-child(3),
.interactivity-section:nth-child(3),
.personal-cta:nth-child(3) {
  animation-delay: 120ms;
}
.hero-card:nth-child(4),
.section:nth-child(4),
.reactions-section:nth-child(4),
.interactivity-section:nth-child(4),
.personal-cta:nth-child(4) {
  animation-delay: 160ms;
}
.hero-card:nth-child(5),
.section:nth-child(5),
.reactions-section:nth-child(5),
.interactivity-section:nth-child(5),
.personal-cta:nth-child(5) {
  animation-delay: 200ms;
}
.hero-card:nth-child(6),
.section:nth-child(6),
.reactions-section:nth-child(6),
.interactivity-section:nth-child(6),
.personal-cta:nth-child(6) {
  animation-delay: 240ms;
}
.hero-card:nth-child(7),
.section:nth-child(7),
.reactions-section:nth-child(7),
.interactivity-section:nth-child(7),
.personal-cta:nth-child(7) {
  animation-delay: 280ms;
}
.hero-card:nth-child(8),
.section:nth-child(8),
.reactions-section:nth-child(8),
.interactivity-section:nth-child(8),
.personal-cta:nth-child(8) {
  animation-delay: 320ms;
}
.hero-card:nth-child(9),
.section:nth-child(9),
.reactions-section:nth-child(9),
.interactivity-section:nth-child(9),
.personal-cta:nth-child(9) {
  animation-delay: 360ms;
}
.hero-card:nth-child(10),
.section:nth-child(10),
.reactions-section:nth-child(10),
.interactivity-section:nth-child(10),
.personal-cta:nth-child(10) {
  animation-delay: 400ms;
}
.hero-card:nth-child(11),
.section:nth-child(11),
.reactions-section:nth-child(11),
.interactivity-section:nth-child(11),
.personal-cta:nth-child(11) {
  animation-delay: 440ms;
}
.hero-card:nth-child(12),
.section:nth-child(12),
.reactions-section:nth-child(12),
.interactivity-section:nth-child(12),
.personal-cta:nth-child(12) {
  animation-delay: 480ms;
}
.hero-card:nth-child(13),
.section:nth-child(13),
.reactions-section:nth-child(13),
.interactivity-section:nth-child(13),
.personal-cta:nth-child(13) {
  animation-delay: 520ms;
}
.hero-card:nth-child(14),
.section:nth-child(14),
.reactions-section:nth-child(14),
.interactivity-section:nth-child(14),
.personal-cta:nth-child(14) {
  animation-delay: 560ms;
}
.hero-card:nth-child(15),
.section:nth-child(15),
.reactions-section:nth-child(15),
.interactivity-section:nth-child(15),
.personal-cta:nth-child(15) {
  animation-delay: 600ms;
}
.hero-card:nth-child(16),
.section:nth-child(16),
.reactions-section:nth-child(16),
.interactivity-section:nth-child(16),
.personal-cta:nth-child(16) {
  animation-delay: 640ms;
}
.hero-card:nth-child(17),
.section:nth-child(17),
.reactions-section:nth-child(17),
.interactivity-section:nth-child(17),
.personal-cta:nth-child(17) {
  animation-delay: 680ms;
}
.hero-card:nth-child(18),
.section:nth-child(18),
.reactions-section:nth-child(18),
.interactivity-section:nth-child(18),
.personal-cta:nth-child(18) {
  animation-delay: 720ms;
}
.hero-card:nth-child(19),
.section:nth-child(19),
.reactions-section:nth-child(19),
.interactivity-section:nth-child(19),
.personal-cta:nth-child(19) {
  animation-delay: 760ms;
}
.hero-card:nth-child(20),
.section:nth-child(20),
.reactions-section:nth-child(20),
.interactivity-section:nth-child(20),
.personal-cta:nth-child(20) {
  animation-delay: 800ms;
}

@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/schedule-detail/schedule-detail.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,oDAAA;EACA,0DAAA;EACA,8BAAA;EACA,gCAAA;EACA,+BAAA;EACA,2BAAA;EACA,uDAAA;EACA,wDAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAKA;EACE,aAAA;AAFF;AAIE;EACE,aAAA;EACA,wCAAA;EACA,yEAAA;EACA,0BAAA;EACA,4CAAA;EACA,mBAAA;AAFJ;AAKE;EACE,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,4CAAA;EACA,mBAAA;AAHJ;AAKI;EAAS,UAAA;AAFb;AAGI;EAAS,UAAA;AAAb;AACI;EAAS,UAAA;AAEb;AACE;EACE,YAAA;EACA,mBAAA;EACA,yEAAA;EACA,0BAAA;EACA,4CAAA;EACA,mBAAA;AACJ;;AAGA;EACE;IAAK,2BAAA;EACL;EAAA;IAAO,4BAAA;EAGP;AACF;AAAA;EACE,kBAAA;EACA,sEAAA;EACA,gBAAA;EACA,gBAAA;AAEF;AAAE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mCAAA;AAEJ;AACE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kLAAA;AACJ;AAOE;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AASE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,wCAAA;EACA,qCAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAPJ;AASI;EACE,eAAA;AAPN;AAUI;EACE,YAAA;EACA,aAAA;AARN;AAYE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAVJ;AAaE;EACE,iBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAXJ;AAcE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAZJ;;AAiBA;EACE,oBAAA;AAdF;AAgBE;EACE,eAAA;EACA,gBAAA;AAdJ;;AAmBA;EACE,kBAAA;AAhBF;AAkBE;EACE,kBAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;AAhBJ;AAkBI;EACE,gBAAA;AAhBN;AAmBI;EACE,eAAA;EACA,mBAAA;AAjBN;AAoBI;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AAlBN;AAqBI;;;EAGE,eAAA;AAnBN;AAsBI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApBN;;AA0BA;EACE,gBAAA;AAvBF;AAyBE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AAvBJ;AAyBI;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAvBN;;AA6BA;EACE,sBAAA;AA1BF;AA4BE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,iCAAA;EACA,qCAAA;EACA,eAAA;EACA,+EAAA;EACA,eAAA;AA3BJ;AA6BI;EACE,sBAAA;EACA,0CAAA;AA3BN;AA8BI;EACE,sBAAA;AA5BN;AA+BI;EACE,wCAAA;EACA,4DAAA;AA7BN;AAgCI;EACE,iBAAA;EACA,cAAA;AA9BN;AAiCI;EACE,kBAAA;EACA,gBAAA;EACA,mCAAA;AA/BN;;AAsCE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAnCJ;AAsCE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,qCAAA;EACA,eAAA;EACA,+EAAA;AApCJ;AAsCI;EACE,2BAAA;EACA,2CAAA;AApCN;AAuCI;EACE,sBAAA;AArCN;AAyCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAvCJ;AAyCI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAvCN;AA0CI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AAxCN;AA4CE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AA1CJ;AA4CI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1CN;AA6CI;EACE,cAAA;EACA,iBAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA3CN;AA8CI;EACE,cAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA5CN;;AAmDE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhDJ;AAmDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,qCAAA;AAjDJ;AAmDI;EACE,iBAAA;EACA,iCAAA;EACA,cAAA;AAjDN;AAoDI;EACE,kBAAA;EACA,gBAAA;EACA,iCAAA;AAlDN;;AA0DI;EACE,2BAAA;AAvDN;AA0DI;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;AAxDN;;AA+DE;EACE,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,qCAAA;EACA,mBAAA;AA5DJ;AA8DI;EACE,gBAAA;AA5DN;AAgEE;EACE,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA9DJ;AAiEE;EACE,iBAAA;EACA,iCAAA;EACA,iBAAA;AA/DJ;;AAoEA;EACE,gBAAA;EACA,oBAAA;AAjEF;;AAoEA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;EACA,iCAAA;AAjEF;AAmEE;EACE,iCAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAjEJ;AAmEI;EACE,2CAAA;EACA,qCAAA;EACA,2CAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAjEN;AAmEM;EACE,iBAAA;EACA,iBAAA;AAjER;AAoEM;EACE,aAAA;AAlER;;AAyEA;EACE,mBAAA;AAtEF;AAwEE;EACE,iCAAA;EACA,mBAAA;EACA,YAAA;AAtEJ;AAwEI;EACE,2CAAA;EACA,qCAAA;EACA,2CAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAtEN;AAwEM;EACE,eAAA;EACA,iBAAA;AAtER;AAyEM;EACE,aAAA;AAvER;;AA6EA;EACE,iCAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,iCAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,cAAA;AA1EF;;AA8EA;EACE,sBAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,+EAAA;AA3EF;AA6EE;EACE,2BAAA;AA3EJ;AA8EE;EACE,sBAAA;AA5EJ;AA+EE;EACE,8BAAA;AA7EJ;AAgFE;EACE,2DAAA;EACA,iCAAA;EACA,oEAAA;AA9EJ;AAiFE;EACE,sCAAA;EACA,sCAAA;EACA,uEAAA;AA/EJ;AAkFE;EACE,YAAA;EACA,mBAAA;AAhFJ;AAiFI;EAAU,eAAA;AA9Ed;AA+EI;EAAW,eAAA;AA5Ef;AA+EE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AA7EJ;AA+EI;EACE,iBAAA;EACA,cAAA;AA7EN;AAgFI;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9EN;AAkFE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAAA;AAhFJ;AAkFI;EACE,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;AAhFN;;AAqFA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAlFF;;AAsFA;EACE,aAAA;EACA,0BAAA;EACA,MAAA;AAnFF;;AAsFA;EACE;IACE,uBAAA;EAnFF;EAsFA;IACE,oBAAA;EApFF;EAuFA;IACE,sBAAA;EArFF;EAwFA;IACE,sBAAA;EAtFF;EAyFA;IACE,gCAAA;IACA,SAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;EAvFF;EA2FE;IACE,wCAAA;IACA,cAAA;EAzFJ;EA2FI;;IAEE,wCAAA;EAzFN;EA8FA;IACE,gBAAA;IACA,SAAA;IACA,iBAAA;EA5FF;AACF;AAgGA;;;;;EAKE,UAAA;EACA,8CAAA;AA9FF;AAiGI;;;;;EACE,qBAAA;AA3FN;AA0FI;;;;;EACE,qBAAA;AApFN;AAmFI;;;;;EACE,sBAAA;AA7EN;AA4EI;;;;;EACE,sBAAA;AAtEN;AAqEI;;;;;EACE,sBAAA;AA/DN;AA8DI;;;;;EACE,sBAAA;AAxDN;AAuDI;;;;;EACE,sBAAA;AAjDN;AAgDI;;;;;EACE,sBAAA;AA1CN;AAyCI;;;;;EACE,sBAAA;AAnCN;AAkCI;;;;;EACE,sBAAA;AA5BN;AA2BI;;;;;EACE,sBAAA;AArBN;AAoBI;;;;;EACE,sBAAA;AAdN;AAaI;;;;;EACE,sBAAA;AAPN;AAMI;;;;;EACE,sBAAA;AAAN;AADI;;;;;EACE,sBAAA;AAON;AARI;;;;;EACE,sBAAA;AAcN;AAfI;;;;;EACE,sBAAA;AAqBN;AAtBI;;;;;EACE,sBAAA;AA4BN;AA7BI;;;;;EACE,sBAAA;AAmCN;AApCI;;;;;EACE,sBAAA;AA0CN;;AArCA;EACE;IACE,UAAA;IACA,2BAAA;EAwCF;EAtCA;IACE,UAAA;IACA,wBAAA;EAwCF;AACF","sourcesContent":[":host {\n  --detail-surface: #f5f7fa;\n  --detail-card-bg: #ffffff;\n  --detail-card-radius: 16px;\n  --detail-card-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);\n  --detail-card-shadow-hover: 0 4px 24px rgba(0, 0, 0, 0.10);\n  --detail-text-primary: #1a1a2e;\n  --detail-text-secondary: #6b7280;\n  --detail-text-tertiary: #9ca3af;\n  --detail-pill-radius: 100px;\n  --detail-transition: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  --detail-spring: 400ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\nion-title.title-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  left: 0;\n  right: 0;\n  width: auto;\n  max-width: calc(100% - 120px);\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n\n\n// ====== SKELETON LOADER ======\n.skeleton-container {\n  padding: 16px;\n\n  .skeleton-hero {\n    height: 180px;\n    border-radius: var(--detail-card-radius);\n    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);\n    background-size: 300% 100%;\n    animation: shimmer 1.8s ease-in-out infinite;\n    margin-bottom: 20px;\n  }\n\n  .skeleton-line {\n    height: 14px;\n    border-radius: 8px;\n    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);\n    background-size: 300% 100%;\n    animation: shimmer 1.8s ease-in-out infinite;\n    margin-bottom: 12px;\n\n    &.w-60 { width: 60%; }\n    &.w-80 { width: 80%; }\n    &.w-40 { width: 40%; }\n  }\n\n  .skeleton-card {\n    height: 80px;\n    border-radius: 12px;\n    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);\n    background-size: 300% 100%;\n    animation: shimmer 1.8s ease-in-out infinite;\n    margin-bottom: 12px;\n  }\n}\n\n@keyframes shimmer {\n  0% { background-position: 300% 0; }\n  100% { background-position: -300% 0; }\n}\n\n// ====== HERO CARD ======\n.hero-card {\n  position: relative;\n  border-radius: 0 0 var(--detail-card-radius) var(--detail-card-radius);\n  overflow: hidden;\n  margin-bottom: 0;\n\n  .hero-bg {\n    position: absolute;\n    inset: 0;\n    z-index: 0;\n    background-color: var(--hero-color);\n  }\n\n  .hero-gradient {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    background: linear-gradient(\n      180deg,\n      color-mix(in srgb, var(--hero-color) 30%, transparent) 0%,\n      color-mix(in srgb, var(--hero-color) 85%, transparent) 60%,\n      var(--hero-color) 100%\n    );\n  }\n\n  .hero-body {\n    position: relative;\n    z-index: 2;\n    padding: 64px 20px 28px;\n  }\n\n  .meta-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 14px;\n  }\n\n  .meta-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 14px;\n    border-radius: var(--detail-pill-radius);\n    background: rgba(255, 255, 255, 0.25);\n    transform: translateZ(0);\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: #fff;\n\n    ion-icon {\n      font-size: 1rem;\n    }\n\n    .dot {\n      opacity: 0.6;\n      margin: 0 2px;\n    }\n  }\n\n  .track-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 16px;\n  }\n\n  .track-chip {\n    padding: 4px 12px;\n    border-radius: var(--detail-pill-radius);\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n  }\n\n  .session-title {\n    font-size: 1.65rem;\n    font-weight: 700;\n    color: #fff;\n    margin: 0;\n    line-height: 1.2;\n    letter-spacing: -0.3px;\n  }\n}\n\n// ====== SECTIONS ======\n.section {\n  padding: 20px 20px 0;\n\n  .section-title {\n    font-size: 1rem;\n    margin: 0 0 10px;\n  }\n}\n\n// Description\n.description-section {\n  overflow-x: hidden;\n\n  .section-body {\n    font-size: 0.92rem;\n    line-height: 1.65;\n    color: var(--detail-text-secondary);\n    font-weight: 400;\n\n    ::ng-deep p {\n      margin: 0 0 12px;\n    }\n\n    ::ng-deep img {\n      max-width: 100%;\n      border-radius: 10px;\n    }\n\n    ::ng-deep iframe {\n      max-width: 100%;\n      width: 100%;\n      border: 0;\n      border-radius: 10px;\n    }\n\n    ::ng-deep video,\n    ::ng-deep embed,\n    ::ng-deep object {\n      max-width: 100%;\n    }\n\n    ::ng-deep table {\n      width: 100%;\n      max-width: 100%;\n      overflow-x: auto;\n      display: block;\n    }\n  }\n}\n\n// Video\n.video-section {\n  padding-top: 8px;\n\n  .video-wrapper {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);\n\n    iframe {\n      width: 100%;\n      height: 100%;\n      border: 0;\n    }\n  }\n}\n\n// Reactions\n.reactions-section {\n  padding: 16px 20px 8px;\n\n  .reactions-row {\n    display: flex;\n    justify-content: center;\n    gap: 6px;\n  }\n\n  .reaction-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    padding: 8px 14px;\n    border-radius: 12px;\n    background: var(--detail-card-bg);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    cursor: pointer;\n    transition: transform var(--detail-spring), box-shadow var(--detail-transition);\n    min-width: 60px;\n\n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    }\n\n    &:active {\n      transform: scale(0.92);\n    }\n\n    &.active {\n      border-color: var(--menu-color, #2973a2);\n      background: rgba(from var(--menu-color, #2973a2) r g b / 0.08);\n    }\n\n    .reaction-emoji {\n      font-size: 1.5rem;\n      line-height: 1;\n    }\n\n    .reaction-count {\n      font-size: 0.75rem;\n      font-weight: 600;\n      color: var(--detail-text-secondary);\n    }\n  }\n}\n\n// Speakers\n.speakers-section {\n  .speakers-scroll {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .speaker-card {\n    flex: 1 1 130px;\n    max-width: 160px;\n    min-width: 120px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 16px 12px;\n    border-radius: 14px;\n    background: var(--detail-card-bg);\n    box-shadow: var(--detail-card-shadow);\n    cursor: pointer;\n    transition: transform var(--detail-spring), box-shadow var(--detail-transition);\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: var(--detail-card-shadow-hover);\n    }\n\n    &:active {\n      transform: scale(0.96);\n    }\n  }\n\n  .speaker-avatar {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    background: #f0f0f0;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    .avatar-fallback {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 1.5rem;\n      color: #aaa;\n    }\n  }\n\n  .speaker-info {\n    text-align: center;\n    min-width: 0;\n    width: 100%;\n\n    .speaker-name {\n      display: block;\n      font-size: 0.82rem;\n      font-weight: 600;\n      color: var(--detail-text-primary);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .speaker-title {\n      display: block;\n      font-size: 0.7rem;\n      color: var(--detail-text-secondary);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-top: 2px;\n    }\n\n    .speaker-company {\n      display: block;\n      font-size: 0.68rem;\n      color: var(--detail-text-tertiary);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-top: 1px;\n    }\n  }\n}\n\n// Locations\n.locations-section {\n  .location-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .location-item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    background: var(--detail-card-bg);\n    box-shadow: var(--detail-card-shadow);\n\n    .loc-icon {\n      font-size: 1.2rem;\n      color: var(--menu-color, #2973a2);\n      flex-shrink: 0;\n    }\n\n    span {\n      font-size: 0.88rem;\n      font-weight: 500;\n      color: var(--detail-text-primary);\n    }\n  }\n}\n\n// Documents\n.documents-section {\n  ::ng-deep app-documents {\n    .cdk-virtual-scroll-viewport {\n      max-height: none !important;\n    }\n\n    ion-item {\n      --padding-start: 0;\n      --inner-padding-end: 0;\n      --background: transparent;\n    }\n  }\n}\n\n// Custom Fields\n.custom-fields-section {\n  .custom-field {\n    padding: 16px;\n    border-radius: 12px;\n    background: var(--detail-card-bg);\n    box-shadow: var(--detail-card-shadow);\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .cf-label {\n    font-size: 0.7rem;\n    font-weight: 700;\n    color: var(--detail-text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 6px;\n  }\n\n  .cf-value {\n    font-size: 0.9rem;\n    color: var(--detail-text-primary);\n    line-height: 1.55;\n  }\n}\n\n// ====== INTERACTIVITY TABS ======\n.interactivity-section {\n  margin-top: 24px;\n  padding: 0 20px 20px;\n}\n\n.segment-sticky {\n  position: sticky;\n  top: 0;\n  z-index: 15;\n  padding: 8px 0;\n  background: var(--detail-surface);\n\n  ion-segment {\n    --background: rgba(0, 0, 0, 0.05);\n    border-radius: 12px;\n    padding: 3px;\n    min-height: 44px;\n\n    ion-segment-button {\n      --background-checked: var(--detail-card-bg);\n      --color: var(--detail-text-secondary);\n      --color-checked: var(--menu-color, #2973a2);\n      --indicator-color: transparent;\n      --border-radius: 10px;\n      font-size: 0.8rem;\n      font-weight: 500;\n      min-height: 38px;\n      letter-spacing: 0;\n\n      ion-icon {\n        font-size: 1.1rem;\n        margin-right: 4px;\n      }\n\n      &::part(indicator) {\n        display: none;\n      }\n    }\n  }\n}\n\n// Desktop right column segment bar\n.sidebar-segment {\n  margin-bottom: 16px;\n\n  ion-segment {\n    --background: rgba(0, 0, 0, 0.05);\n    border-radius: 12px;\n    padding: 3px;\n\n    ion-segment-button {\n      --background-checked: var(--detail-card-bg);\n      --color: var(--detail-text-secondary);\n      --color-checked: var(--menu-color, #2973a2);\n      --indicator-color: transparent;\n      --border-radius: 10px;\n      font-size: 0.8rem;\n      min-height: 38px;\n\n      ion-icon {\n        font-size: 1rem;\n        margin-right: 4px;\n      }\n\n      &::part(indicator) {\n        display: none;\n      }\n    }\n  }\n}\n\n.sidebar-content {\n  background: var(--detail-card-bg);\n  border-radius: 14px;\n  box-shadow: var(--detail-card-shadow);\n  overflow: hidden;\n}\n\n.tab-content {\n  background: var(--detail-card-bg);\n  border-radius: 14px;\n  box-shadow: var(--detail-card-shadow);\n  overflow: hidden;\n  margin-top: 12px;\n}\n\n.tab-content-inner {\n  padding: 4px 0;\n}\n\n// ====== PERSONAL SCHEDULE CTA ======\n.personal-cta {\n  padding: 8px 20px 24px;\n}\n\n.cta-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 16px 20px;\n  border-radius: 14px;\n  border: none;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform var(--detail-spring), box-shadow var(--detail-transition);\n\n  &:hover {\n    transform: translateY(-1px);\n  }\n\n  &:active {\n    transform: scale(0.97);\n  }\n\n  &.has-badge {\n    justify-content: space-between;\n  }\n\n  &.added {\n    background: rgba(from var(--menu-color, #2973a2) r g b / 0.1);\n    color: var(--menu-color, #2973a2);\n    border: 1.5px solid rgba(from var(--menu-color, #2973a2) r g b / 0.25);\n  }\n\n  &.add {\n    background: var(--menu-color, #2973a2);\n    color: var(--menu-text-color, #ffffff);\n    box-shadow: 0 4px 20px rgba(from var(--menu-color, #2973a2) r g b / 0.35);\n  }\n\n  &.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    &:hover { transform: none; }\n    &:active { transform: none; }\n  }\n\n  .cta-start {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n\n    ion-icon {\n      font-size: 1.3rem;\n      flex-shrink: 0;\n    }\n\n    .cta-label {\n      font-size: 0.95rem;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .cta-badge {\n    flex-shrink: 0;\n    font-size: 0.78rem;\n    font-weight: 500;\n    padding: 3px 10px;\n    border-radius: 20px;\n    background: rgba(255, 255, 255, 0.15);\n    color: inherit;\n\n    &.sold-out {\n      background: rgba(255, 255, 255, 0.25);\n      font-weight: 600;\n      font-size: 0.72rem;\n      text-transform: uppercase;\n      letter-spacing: 0.3px;\n    }\n  }\n}\n\n.conflict-message {\n  margin: 10px 0 0;\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: #e53935;\n  text-align: center;\n  line-height: 1.4;\n}\n\n// ====== DESKTOP GRID ======\n.detail-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0;\n}\n\n@media (min-width: 992px) {\n  .hero-card .hero-body {\n    padding: 80px 32px 28px;\n  }\n\n  .section {\n    padding: 24px 32px 0;\n  }\n\n  .reactions-section {\n    padding: 16px 32px 8px;\n  }\n\n  .personal-cta {\n    padding: 8px 32px 32px;\n  }\n\n  .detail-grid {\n    grid-template-columns: 1.2fr 1fr;\n    gap: 24px;\n    padding: 24px 0;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n\n  .detail-main {\n    .hero-card {\n      border-radius: var(--detail-card-radius);\n      margin: 0 32px;\n\n      .hero-bg,\n      .hero-gradient {\n        border-radius: var(--detail-card-radius);\n      }\n    }\n  }\n\n  .detail-sidebar {\n    position: sticky;\n    top: 16px;\n    align-self: start;\n  }\n}\n\n// ====== FADE IN ANIMATION ======\n.hero-card,\n.section,\n.reactions-section,\n.interactivity-section,\n.personal-cta {\n  opacity: 0;\n  animation: fadeSlideUp 450ms ease-out forwards;\n\n  @for $i from 1 through 20 {\n    &:nth-child(#{$i}) {\n      animation-delay: #{$i * 40}ms;\n    }\n  }\n}\n\n@keyframes fadeSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
